<!--
 * @Descripttion: 黄修改
 * @version: 
 * @Author: szj
 * @Date: 2024-09-02 09:14:23
 * @LastEditors: szj
 * @LastEditTime: 2025-12-03 15:49:27
-->
<template>
  <div class="project-wayline-wrapper" style="display: flex; height: 100%">
    <div style="width: 200px; height: 570px; border-right: 1px solid #2cd0ab">
      <waylineFloder :readonly="true" @select="onFolderSelect" />
    </div>
    <div style="flex: 1; height: 100%; overflow: hidden">
      <a-spin
        :spinning="loading"
        :delay="300"
        tip="downloading"
        size="large"
        wrapperClassName="spin-height"
        style="height: 100%"
      >
        <div style="height: 50px; line-height: 50px; font-weight: 450">
          <a-row>
            <a-col :span="24" class="searchbar">
              <div style="display: flex; align-items: center">
                <a-input
                  placeholder="请输入关键字查询"
                  style="flex: 1"
                  v-model:value="formState.keyWord"
                  allow-clear
                  @change="freshlist"
                  @pressEnter="getWaylines(false)"
                >
                  <template #addonBefore>
                    <a-select
                      v-model:value="formState.type"
                      style="width: 100px"
                    >
                      <a-select-option
                        :value="item.value"
                        v-for="(item, index) in typeList"
                        :key="index"
                        >{{ item.label }}</a-select-option
                      >
                    </a-select>
                  </template>
                </a-input>
                <div>
                  <a-button
                    type="primary"
                    @click="getWaylines(false)"
                    :icon="h(SearchOutlined)"
                    >查询</a-button
                  >
                </div>
              </div>
            </a-col>
          </a-row>
        </div>
        <div :style="{ height: '520px' }" class="scrollbar wayline-content">
          <div class="wayline-content-left">
            <div
              class="content-left-item"
              :class="lineType == 1 ? 'content-left-item-active' : ''"
              @click="checkType(1)"
            >
              <div class="left-item-img icon-all"></div>
              <div class="left-item-txt">全部</div>
            </div>
            <div
              class="content-left-item"
              :class="lineType == 2 ? 'content-left-item-active' : ''"
              @click="checkType(2)"
            >
              <div
                class="left-item-img"
                :class="lineType == 2 ? 'icon-ai-active' : 'icon-ai'"
              ></div>
              <div class="left-item-txt">AI航线</div>
            </div>
            <div
              class="content-left-item"
              :class="lineType == 3 ? 'content-left-item-active' : ''"
              @click="checkType(3)"
            >
              <div
                class="left-item-img"
                :class="
                  lineType == 3 ? 'icon-ordinary-active' : 'icon-ordinary'
                "
              ></div>
              <div class="left-item-txt">普通航线</div>
            </div>
          </div>
          <div
            id="data"
            class="uranus-scrollbar"
            v-if="waylinesData.data.length !== 0"
            @scroll="onScroll"
          >
            <div v-for="wayline in waylinesData.data" :key="wayline.id">
              <div
                class="wayline-panel"
                style="padding-top: 5px"
                @click="selectRoute(wayline)"
              >
                <div class="title">
                  <div
                    class="pr10"
                    style="
                      width: 100%;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                    "
                  >
                    {{ wayline.name }}
                  </div>
                </div>
                <div class="wayline-item-row">
                  <div class="wayline-item-list list-border">
                    <div class="item-label">飞机机型：</div>
                    <div class="item-value">
                      {{
                        Object.keys(EDeviceType)[
                          Object.values(EDeviceType).indexOf(
                            wayline.drone_model_key
                          )
                        ]
                      }}
                    </div>
                  </div>
                  <div class="wayline-item-list">
                    <div class="item-label">飞机次数：</div>
                    <div class="item-value">{{ wayline.fly_times || 0 }}</div>
                  </div>
                </div>
                <div class="wayline-item-row">
                  <div class="wayline-item-list list-border">
                    <div class="item-label">AI事件：</div>
                    <div class="item-value">
                      {{ wayline.ai_times || 0 }}
                    </div>
                  </div>
                  <div class="wayline-item-list">
                    <div class="item-label">总里程：</div>
                    <div class="item-value">
                      {{ getMileage(wayline.mileage) || 0 }}km
                    </div>
                  </div>
                </div>
                <!-- <div class="ml10 mt5">
                  <span>
                    <RocketOutlined />
                  </span>
                  <span class="ml5"></span>
                  <span class="ml10">
                    <CameraFilled
                      style="border-top: 1px solid; padding-top: -3px"
                    />
                  </span>
                  <span
                    class="ml5"
                    v-for="payload in wayline.payload_model_keys"
                    :key="payload.id"
                  >
                    {{
                      Object.keys(EDeviceType)[
                        Object.values(EDeviceType).indexOf(payload)
                      ]
                    }}
                  </span>
                </div>
                <div class="mt5 ml10">
                  <span class="mr10"
                    >更新时间：
                    {{ new Date(wayline.update_time).toLocaleString() }}</span
                  >
                </div> -->
              </div>
            </div>
          </div>
          <div v-else>
            <a-empty :image-style="{ height: '60px', marginTop: '60px' }" />
          </div>
        </div>
      </a-spin>
    </div>
  </div>
</template>

    <script lang="ts" setup>
import { reactive } from "@vue/reactivity";
import { message } from "ant-design-vue";
import { onMounted, ref, defineEmits, h } from "vue";
import {
  deleteWaylineFile,
  downloadWaylineFile,
  getWaylineFiles,
  importKmzFile,
} from "/@/api/wayline";
import waylineFloder from "./waylineFloder.vue";
import { ELocalStorageKey, ERouterName } from "/@/types";
import {
  EllipsisOutlined,
  RocketOutlined,
  CameraFilled,
  UserOutlined,
  SelectOutlined,
  SearchOutlined,
} from "@ant-design/icons-vue";
import { EDeviceType } from "/@/types/device";
import { useMyStore } from "/@/store";
import { WaylineFile } from "/@/types/wayline";
import { downloadFile } from "/@/utils/common";
import { IPage } from "/@/api/http/type";
import { CURRENT_CONFIG } from "/@/api/http/config";
import { load } from "@amap/amap-jsapi-loader";
import { getRoot } from "/@/root";
const typeList = [
  {
    label: "航线名称",
    value: "航线名称",
  },
  {
    label: "飞机机型",
    value: "飞机机型",
  },
  {
    label: "飞行次数",
    value: "飞行次数",
  },
  {
    label: "AI事件",
    value: "AI事件",
  },
  {
    label: "总里程",
    value: "总里程",
  },
];
const emit = defineEmits(["closeWayline"]);

const loading = ref(false);
const store = useMyStore();
const pagination: IPage = {
  page: 1,
  total: -1,
  page_size: 10,
};

const waylinesData = reactive({
  data: [] as WaylineFile[],
});

const root = getRoot();
const workspaceId = localStorage.getItem(ELocalStorageKey.WorkspaceId)!;
const deleteTip = ref(false);
const deleteWaylineId = ref<string>("");
const canRefresh = ref(true);
const lineType = ref(1);
const importVisible = ref<boolean>(
  root.$router.currentRoute.value.name === ERouterName.WAYLINE
);
const height = ref();
const currentFolderId = ref<string | number>("");

interface FormState {
  keyWord: string;
}
const formState = reactive<any>({
  keyWord: "",
  type: "航线名称",
});

onMounted(() => {
  const parent = document.getElementsByClassName("scrollbar").item(0)
    ?.parentNode as HTMLDivElement;
  height.value =
    document.body.clientHeight - parent.firstElementChild!.clientHeight;
  //
});

const onFolderSelect = (item: any) => {
  currentFolderId.value = item.id;
  pagination.page = 1;
  waylinesData.data = [];
  getWaylines(false);
};

function freshlist() {
  if (!formState.keyWord) {
    getWaylines(false);
  }
}
// 切换 航线类型
const checkType = (num: number) => {
  lineType.value = num;
};
// 总里程
const getMileage = (data: any) => {
  let num = 0;
  if (data) {
    num = parseFloat((Number(data) / 1000).toFixed(2));
  }
  return num;
};
function getWaylines(flag = true) {
  if (!canRefresh.value) {
    return;
  }
  canRefresh.value = false;
  getWaylineFiles(
    workspaceId,
    {
      page: pagination.page,
      page_size: pagination.page_size,
      order_by: "update_time desc",
    },
    formState,
    currentFolderId.value
  )
    .then((res) => {
      if (res.code !== 0) {
        return;
      }
      if (flag) {
        waylinesData.data = [...waylinesData.data, ...res.data.list];
        pagination.total = res.data.pagination.total;
        pagination.page = res.data.pagination.page;
      } else {
        waylinesData.data = [...res.data.list];
        pagination.total = res.data.pagination.total;
        pagination.page = res.data.pagination.page;
      }
    })
    .finally(() => {
      canRefresh.value = true;
    });
}

function showWaylineTip(waylineId: string) {
  deleteWaylineId.value = waylineId;
  deleteTip.value = true;
}

function deleteWayline() {
  deleteWaylineFile(workspaceId, deleteWaylineId.value).then((res) => {
    if (res.code === 0) {
      message.success("Wayline file deleted");
    }
    deleteWaylineId.value = "";
    deleteTip.value = false;
    pagination.total = 0;
    pagination.page = 1;
    waylinesData.data = [];
    getWaylines();
  });
}

function downloadWayline(waylineId: string, fileName: string) {
  loading.value = true;
  downloadWaylineFile(workspaceId, waylineId)
    .then((res) => {
      if (!res) {
        return;
      }
      const data = new Blob([res], { type: "application/zip" });
      downloadFile(data, fileName + ".kmz");
    })
    .finally(() => {
      loading.value = false;
    });
}
function selectRoute(wayline: WaylineFile) {
  store.commit("SET_SELECT_WAYLINE_INFO", wayline);
  let params = {
    wayline,
  };
  emit("closeWayline", params);
}

function onScroll(e: any) {
  const element = e.srcElement;
  if (
    element.scrollTop + element.clientHeight >= element.scrollHeight - 5 &&
    Math.ceil(pagination.total / pagination.page_size) > pagination.page &&
    canRefresh.value
  ) {
    pagination.page++;
    getWaylines();
  }
}

interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: string;
  url?: string;
}

interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}
const fileList = ref<FileItem[]>([]);

function beforeUpload(file: FileItem) {
  fileList.value = [file];
  loading.value = true;
  return true;
}
const uploadFile = async () => {
  fileList.value.forEach(async (file: FileItem) => {
    const fileData = new FormData();
    fileData.append("file", file, file.name);
    await importKmzFile(workspaceId, fileData)
      .then((res) => {
        if (res.code === 0) {
          message.success(`${file.name} file uploaded successfully`);
          canRefresh.value = true;
          pagination.total = 0;
          pagination.page = 1;
          waylinesData.data = [];
          getWaylines();
        }
      })
      .finally(() => {
        loading.value = false;
        fileList.value = [];
      });
  });
};
</script>

<style lang="scss" scoped>
.way-box {
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
}
.project-wayline-wrapper {
  width: 100%;
  color: #666;
  overflow-y: auto;
  border: 1px #2cd0ab solid;
}
.wayline-panel {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
  height: 100px;
  width: 95%;
  font-size: 14px;
  border-radius: 2px;
  cursor: pointer;
  border: 1px #eaf9f5 solid;
  .title {
    color: #333;
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 30px;
    font-weight: bold;
    margin: 0px 10px 0 10px;
  }
  .wayline-item-row {
    display: flex;
    align-items: center;
    .list-border {
      border-right: 2px solid #e9e9e9;
    }
    .wayline-item-list {
      width: 50%;
      margin-bottom: 10px;
      display: flex;
      color: #666666;
      .item-label {
        width: 80px;
        text-align: right;
      }
    }
  }
}
.wayline-content {
  display: flex;
  flex-direction: column;
  .wayline-content-left {
    width: 100%;
    height: 40px;
    display: flex;
    .content-left-item {
      height: 36px;
      width: 100%;
      padding-left: 20px;
      display: flex;
      align-items: center;
      border: 1px solid rgba(44, 208, 171, 0.1);
      cursor: pointer;
      .left-item-img {
        width: 16px;
        height: 16px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-origin: border-box;
        margin-right: 10px;
      }
    }

    .icon-all {
      background-image: url("/@/assets/icons/table/wayline-all.png");
    }
    .icon-ai {
      background-image: url("/@/assets/icons/table/wayline-ai.png");
    }
    .icon-ai-active {
      background-image: url("/@/assets/icons/table/ai-icon.png");
    }
    .icon-ordinary {
      background-image: url("/@/assets/icons/table/wayline-ordinary.png");
    }
    .icon-ordinary-active {
      background-image: url("/@/assets/icons/table/task-icon.png");
    }
    .content-left-item-active {
      color: #2cd0ab;
      border-left: 2px solid #2cd0ab;
    }
  }
}
.uranus-scrollbar {
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: #c5c8cc transparent;
  width: calc(100% - 0px);
  height: 480px;
  border-top: 1px solid rgba(44, 208, 171, 1);
  border-left: 1px solid rgba(44, 208, 171, 1);
}
::-webkit-scrollbar {
  width: 8px; /* 修改滚动条宽度 */
}
::-webkit-scrollbar-thumb {
  background: rgba(181, 187, 196, 0.8); /* 修改滚动条滑块的颜色 */
  height: 2px;
}
::-webkit-scrollbar-track {
  background: #fff; /* 修改滚动条轨道的颜色 */
}
.searchbar {
  padding: 0 15px;
  width: 100%;
}
</style>